import { render, staticRenderFns } from "./leaveListStudent.vue?vue&type=template&id=4ddc1722&scoped=true&"
import script from "./leaveListStudent.vue?vue&type=script&lang=js&"
export * from "./leaveListStudent.vue?vue&type=script&lang=js&"
import style0 from "./leaveListStudent.vue?vue&type=style&index=0&id=4ddc1722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddc1722",
  null
  
)

export default component.exports